var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fs-adjustments"},[_c('fs-range-filter-wrapper',{attrs:{"min":"-1","max":"1","defaultValue":"0","routerLink":'/adjustments',"label":"menu.brightness"},model:{value:(_vm.value.brightness),callback:function ($$v) {_vm.$set(_vm.value, "brightness", $$v)},expression:"value.brightness"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }